var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChevronLeft = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 20 32.955"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M19.47 17.759 4.803 32.425a1.81 1.81 0 0 1-2.561 0L.531 30.718a1.81 1.81 0 0 1 0-2.558l11.621-11.682L.529 4.8a1.81 1.81 0 0 1 0-2.558L2.243.531a1.81 1.81 0 0 1 2.561 0L19.47 15.198a1.81 1.81 0 0 1 0 2.561",
  className: "chevron-left_svg__a"
})));
export default SvgChevronLeft;